import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M21 14.25v5.25a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-5.25c0-.398.352-.75.75-.75s.75.352.75.75v5.25h15v-5.25c0-.398.352-.75.75-.75s.75.352.75.75M8.78 8.03l2.47-2.47v8.69a.75.75 0 1 0 1.5 0V5.56l2.47 2.47a.77.77 0 0 0 1.06 0 .77.77 0 0 0 0-1.06l-3.75-3.75A.76.76 0 0 0 12 3a.76.76 0 0 0-.53.22L7.72 6.97a.77.77 0 0 0 0 1.06.77.77 0 0 0 1.06 0" />
  </>
);

const Upload = Icon('upload', svgContents);

export default Upload;
